const Joi = require("joi");

const kioskSetupSchema = (data) => {
    const schema = Joi.object({
        selectedFacility: Joi.number()
            .required()
            .messages({
                "any.required": "Please select facility.",
                "number.base": "Please select facility.",  // Custom message for type mismatch
            }),

        selectedPod: Joi.number()
            .required()
            .messages({
                "any.required": "Please select pod.",
                "number.base": "Please select pod.",  // Custom message for type mismatch
            }),

        selectedKiosk: Joi.number()
            .required()
            .messages({
                "any.required": "Please select kiosk.",
                "number.base": "Please select kiosk.",  // Custom message for type mismatch
            }),

        verificationCode: Joi.string()
            .trim()
            .required()
            .messages({
                "string.empty": "Please enter verification code.",
                "any.required": "Please enter Verification code.",
            }),
    }).unknown(true); // Allow unknown properties in the data if necessary

    return schema.validate(data, {
        abortEarly: false, // Will return all errors, not just the first one
    });
};

module.exports = kioskSetupSchema;
